import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import PickUp from "./components/pickUp";
import "./agg.css";
import MainArea from "./components/main/main";
import Navbar from "./components/navbar/navbar";
import Sidebar from "./components/sidebar/sidebar";
import Pick from "./components/pick";
import WalletAggregation from "./components/wallet";
import SettingsAggregation from "./components/settings";
import SupportAggregation from "./components/support";
import DriversAggregation from "./components/drivers";
import CollectionCenter from "./components/collectionCenter";
import Collectionn from "./components/collectionCenter/collections";
import AggregationHistory from "./components/history";
import AggregationNotification from "./components/notification";
// import MessagesComponent from "./components/messages";
import NavbarMobile from "./components/navbarMobile/navbar";
import MessagesComponents from "./components/messages/messagesComponents";
import WithInactivityTimer from "../../../inactivityTimer/withActivityTimer";
import { useSnackbar } from "notistack";
import Pusher from "pusher-js";

const CustomSnackbarContent = ({ data, history }) => {
  // console.log(history);
  return (
    <div
      style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
      onClick={() => history.push("/dashboard/notification")}
    >
      <span style={{ marginRight: "10px" }}>🚀</span>
      <div>
        <strong>Alert !</strong>
        <p>{data}</p>
      </div>
    </div>
  );
};

const AggregationDashboard = ({ modalStatus }) => {
  const location = useLocation();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [titleName, setTitleName] = useState("Dashboard");
  const [open, setOpen] = useState(false);

  const [isMobile, setIsMobile] = useState(false);

  const openSidebar = () => {
    setSidebarOpen(true);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  // console.log(isMobile);

  const centerInfo = JSON.parse(localStorage.getItem("centerInfo"));

  // Sound notification function
  const playSound = () => {
    const audio = new Audio("/notification.mp3"); // Path to your sound file
    audio.play().catch((e) => console.error("Error playing sound:", e));
  };

  useEffect(() => {
    var pusher = new Pusher("4a2216be62f989b542473016ba7fc057", {
      cluster: "mt1",
      wsHost: "websocket.monicredit.com",
      wsPort: 443,
    });

    var channel = pusher.subscribe(
      `aggregation-center-${centerInfo?.aggregation_center?.id}`
    );

    const handleSendNotification = (data) => {
      // console.log(data)
      const message = data?.message || "Hello, You have new notification !";
      playSound();
      enqueueSnackbar(
        <CustomSnackbarContent data={message} history={history} />,
        {
          // variant: "info",
          style: { backgroundColor: "#231F20", color: "white" },
          autoHideDuration: 10000, // 10000 milliseconds = 10 seconds
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        }
      );
      // console.log(data);
      // window.location.reload();
    };

    channel.bind("aggregation-center-notification", handleSendNotification);

    // Cleanup
    return () => {
      channel.unbind("aggregation-center-notification", handleSendNotification);
      channel.unsubscribe();
    };
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 500px)");
    setIsMobile(mediaQuery.matches);
    const handleMediaQueryChange = (event) => {
      setIsMobile(event.matches);
    };
    mediaQuery.addEventListener("change", handleMediaQueryChange);
    return () => {
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, []);

  return (
    <div className="containerss">
      {isMobile ? (
        <NavbarMobile
          sidebarOpen={sidebarOpen}
          openSidebar={openSidebar}
          titleName={titleName}
        />
      ) : (
        <Navbar
          sidebarOpen={sidebarOpen}
          openSidebar={openSidebar}
          titleName={titleName}
        />
      )}

      <Sidebar closeSidebar={closeSidebar} sidebarOpen={sidebarOpen} />
      {location.pathname === "/dashboard" && <MainArea />}

      {location.pathname === "/dashboard/dropOff" && (
        <PickUp setTitleName={setTitleName} />
      )}
      {location.pathname === "/dashboard/pickUp" && (
        <Pick setTitleName={setTitleName} />
      )}
      {location.pathname === "/dashboard/drivers" && (
        <DriversAggregation setTitleName={setTitleName} />
      )}
      {location.pathname === "/dashboard/collectionCenter" && (
        <CollectionCenter setTitleName={setTitleName} />
      )}
      {location.pathname === "/dashboard/support" && (
        <SupportAggregation setTitleName={setTitleName} />
      )}
      {location.pathname === "/dashboard/settings" && (
        <SettingsAggregation setTitleName={setTitleName} />
      )}
      {location.pathname === "/dashboard/wallet" && (
        <WalletAggregation setTitleName={setTitleName} />
      )}
      {location.pathname === "/dashboard/collections" && (
        <Collectionn setTitleName={setTitleName} />
      )}
      {location.pathname === "/dashboard/history" && (
        <AggregationHistory setTitleName={setTitleName} />
      )}
      {location.pathname === "/dashboard/notification" && (
        <AggregationNotification setTitleName={setTitleName} />
      )}
      {location.pathname === "/dashboard/message" && (
        <MessagesComponents setTitleName={setTitleName} />
      )}
    </div>
  );
};

// export default AggregationDashboard;
export default WithInactivityTimer(AggregationDashboard);
